<form [formGroup]="form" class="flex w-full flex-col items-start gap-(--spacing-layout-l)">
    <p class="text-body-large text-bodyText">{{ 'QUESTIONS.ASK.DESCRIPTION' | translate }}</p>

    <div class="w-full">
        <app-select formControlName="topic" [label]="'QUESTIONS.ASK.TOPIC_LABEL' | translate" [options]="topicOptions()" optionLabel="label" optionValue="value" [fluid]="true" appendTo="body" inputId="ask-question-topic" />
    </div>

    @if (isDealTopic()) {
        <div class="w-full">
            <app-select
                formControlName="dealOpportunityId"
                [label]="'QUESTIONS.ASK.DEAL' | translate"
                [options]="dealOptions()"
                optionLabel="label"
                optionValue="value"
                [fluid]="true"
                appendTo="body"
                inputId="ask-question-deal"
                [helpText]="'QUESTIONS.ASK.DEAL_HINT' | translate"
            />
        </div>

        @if (hasNoSelectableDeals()) {
            <p class="text-caption text-secondaryLabel">{{ 'QUESTIONS.ASK.DEAL_EMPTY' | translate }}</p>
        }

        <div class="w-full">
            <app-select formControlName="type" [label]="'QUESTIONS.ASK.TYPE' | translate" [options]="typeOptions()" optionLabel="label" optionValue="value" [fluid]="true" appendTo="body" inputId="ask-question-type" />
        </div>

        <div class="w-full">
            <app-input type="textarea" formControlName="question" [label]="'QUESTIONS.ASK.QUESTION' | translate" id="ask-question-question" [rows]="5" [fluid]="true" [maxLength]="4000" />
        </div>
    } @else {
        <div class="w-full">
            <app-input type="text" formControlName="subject" [label]="'QUESTIONS.ASK.SUBJECT' | translate" id="ask-question-subject" [fluid]="true" [maxLength]="200" [showCharCount]="true" />
        </div>

        <div class="w-full">
            <app-input type="textarea" formControlName="details" [label]="'QUESTIONS.ASK.DETAILS' | translate" id="ask-question-details" [rows]="5" [fluid]="true" [maxLength]="4000" />
        </div>
    }

    <div class="flex w-full justify-end gap-(--spacing-layout-l)">
        <app-button [label]="'GENERIC.CANCEL' | translate" variant="secondary" type="button" (onClick)="cancel()" />
        <app-button [label]="'GENERIC.SUBMIT' | translate" variant="primary" type="button" [loading]="_questionsService.submitting()" [disabled]="_questionsService.submitting()" (onClick)="submit()" />
    </div>
</form>
